<template>
  <div id="connectToSpotifyContainer">
    <h5 style="padding: 0 10px">
      Connect to Spotify in order to see your library
    </h5>
    <VButton
      color="primary"
      style="width: 280px"
      :on-click="connectToSpotify"
    >
      Connect
    </VButton>
  </div>
</template>

<script langs="ts">
import { Vue, Component } from 'vue-property-decorator'
import VButton from '@/components/miniComponents/VButton'
import APIClient from '@/API/APIClient'

@Component({
  components: { VButton }
})
export default class ConnectToSpotify extends Vue {
  async connectToSpotify () {
    const url = await APIClient.Spotify.getRedirectUrl()
    window.location.assign(url)
  }
}
</script>

<style scoped lang="scss">
  #connectToSpotifyContainer {
    margin: auto;
  }
</style>
